import Api from '@/services/Api'

export default {
  getAll () {
    return Api().get('/ap/')
  },
  create (data) {
    return Api().post('/ap' , data)
  },
  edit (data) {
    return Api().put('/ap/'+ data.id, data)
  },
  delete (data) {
    return Api().delete('/ap/' + data.id)
  },

  // Reseller
  getByReseller (ResellerId) {
    return Api().get('/reseller/'+ ResellerId +'/aps')
  }
}
